import { data } from "../LocalData/db";

export const backGroundColorMultiples = (i: number) => {
  if (i === 0) {
    return "rgb(177, 226, 191)";
  } else if (i === 1) {
    return "rgb(180, 194, 233)";
  } else if (i === 2) {
    return "rgb(234, 218, 184)";
  } else if (i === 3) {
    return "rgb(236, 204, 183)";
  } else if (i === 4) {
    return "rgb(177, 226, 191)";
  } else if (i === 4) {
    return "rgb(180, 194, 233)";
  } else if (i === 5) {
    return "rgb(251, 207, 213)";
  } else if (i === 6) {
    return "rgb(255, 244, 244)";
  } else {
    return "rgb(180, 194, 233)";
  }
};
export const bgandheaderColorMultipleForScrollItem = (i: number) => {
  if (i === 0) {
    return data[0].bgcolor;
  } else if (i === 1) {
    return data[1].bgcolor;
  } else if (i === 2) {
    return data[2].bgcolor;
  } else if (i === 3) {
    return data[3].bgcolor;
  } else if (i === 4) {
    return data[4].bgcolor;
  } else if (i === 5) {
    return data[5].bgcolor;
  } else if (i === 6) {
    return data[6].bgcolor;
  } else if (i === 7) {
    return data[7].bgcolor;
  } else {
    return "rgb(180, 194, 233)";
  }
};
